import React, { FC, Dispatch } from 'react';
import styled from '@emotion/styled';
import { PlottedSeries, PlotPoint } from '../../../interfaces/Charts';
import { roundedRect } from './RoundedRectPath';
import { ScaleThreshold } from 'd3-scale';

const Bar = styled.path`
  fill: currentColor;
  stroke-linecap: round;
  &:hover {
    fill-opacity: 1 !important;
  }
`;

const Group = styled.g<{ dimmable: boolean }>`
  ${p =>
    p.dimmable
      ? `&:hover > path {
    fill-opacity: 0.50;
  }`
      : ''}
`;

interface BarsProps {
  series: PlottedSeries<{ value: number }>[];
  colorScale?: ScaleThreshold<number, string>;
  dimmable?: boolean;
  onMouseMove?: (ev: React.MouseEvent<SVGGElement, MouseEvent>) => void;
  onMouseEnter?: (point: PlotPoint) => void;
  onMouseLeave?: Dispatch<void>;
  center?: number;
}

const Bars: FC<BarsProps> = props => {
  const center = props.center ? props.center : 0;
  const dimmable = props.dimmable !== undefined ? props.dimmable : true;
  const onMouseLeave = () => {
    if (props.onMouseLeave) {
      props.onMouseLeave();
    }
  };
  const onMouseEnter = (point: PlotPoint) => {
    if (props.onMouseEnter) {
      props.onMouseEnter(point);
    }
  };
  return (
    <Group onMouseOut={() => onMouseLeave()} dimmable={dimmable}>
      {props.series.map(bar =>
        bar.plottedPoints.map((point, i) => {
          const color = props.colorScale
            ? props.colorScale(point.series.points[point.index].value)
            : point.series.color;

          return (
            <Bar
              key={i}
              color={color}
              onMouseEnter={() => onMouseEnter(point)}
              d={roundedRect(point, center)}
            ></Bar>
          );
        })
      )}
    </Group>
  );
};

export { Bars };
